import React from 'react';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';

const slideUp = keyframes`
	from {
		transform: translateY(100%);
	}
	to {
		transform: translateY(0);
	}
`;

const Backdrop = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			background: rgba(0, 0, 0, 0.65);
			position: fixed;
			left: 0px;
			top: 0px;
			right: 0px;
			bottom: 0px;
			z-index: 3;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			background: rgba(0, 0, 0, 0.65);
			position: fixed;
			left: 0px;
			top: 0px;
			right: 0px;
			bottom: 0px;
			z-index: 3;
		`
	}
`;

const Container = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			border-top-left-radius: 26px;
			border-top-right-radius: 26px;
			background: #FFFFFF;
			position: fixed;
			left: 0px;
			right: 0px;
			bottom: 0px;
			padding: 16px 0px 50px 0px;
			animation: ${slideUp} 0.4s ease-out forwards;
			z-index: 3;
			max-height: 70vh;
			overflow: auto;
    		font-family: Amx-Regular;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			border-top-left-radius: 26px;
			border-top-right-radius: 26px;
			background: #FFFFFF;
			position: fixed;
			left: 0px;
			right: 0px;
			bottom: 0px;
			padding: 0px 0px 25px 0px;
			animation: ${slideUp} 0.4s ease-out forwards;
			z-index: 3;
			max-height: 80vh;
			overflow: auto;
    		font-family: Amx-Regular;
		`
	}
`;

const ItemContainer = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			display: flex;
			align-items: end;
			justify-content: end;
			padding: 8px 16px 8px 16px;
			margin: 0px;
			position: sticky;
			top: 0px;
			background: #fff;
			.title {
				width: 100%;
				position: relative;
				font-size: 18px;
				line-height: 26px;
				display: inline-block;
				font-family: Amx-Black;
				color: #222;
				text-align: left;
			}
			.globaltagsalert {
				width: 100%;
				position: relative;
				border-radius: 16px;
				background-color: #f2f7f9;
				display: flex;
				align-items: center;
				padding: 12px 8px;
				box-sizing: border-box;
				text-align: left;
				font-size: 14px;
				color: #222;
				font-family: Amx-Regular;
			}
			.interfaceParent {
				flex: 1;
				display: flex;
				align-items: center;
				gap: 8px;
			}
			.interface {
				width: 24px;
				position: relative;
				height: 24px;
				overflow: hidden;
				flex-shrink: 0;
			}
			.envolventeIcon {
				position: absolute;
				height: 100%;
				width: 100%;
				top: 0%;
				right: 0%;
				bottom: 0%;
				left: 0%;
				max-width: 100%;
				overflow: hidden;
				max-height: 100%;
				opacity: 0;
			}
			.icon {
				position: absolute;
				height: 24px;
				width: 24px;
				top: 8.33%;
				right: 8.33%;
				bottom: 8.33%;
				left: 8.33%;
				max-width: 100%;
				overflow: hidden;
				max-height: 100%;
			}
			.reactivacinTuLnea {
				flex: 1;
				position: relative;
			}
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			display: flex;
			align-items: end;
			justify-content: end;
			padding: 15px 16px 15px 16px;
			margin: 0px;
			position: sticky;
			top: 0px;
			background: #fff;
		`
	}	
`;

const CloseText = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
			font-size: 16px;
			color: #0071D1;
			margin: 0px 4px 0px 0px;
			line-height: 20px;			
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
			font-size: 16px;
			color: #0071D1;
			margin: 0px 4px 0px 0px;
			line-height: 20px;	
		`
	}	
`;

const CloseIcon = styled.img`
	${props => props.$isContainerTelcel &&
		css`
			width: 24px;
			height: 24px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			width: 24px;
			height: 24px;
		`
	}	
`;

const FixedBottom = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			background: #fff;
			position: fixed;
			bottom: ${props => props.$canHideNativeNavbar ? "30px" : "12px"};
			left: 0px;
			right: 0px;
			padding: ${props => props.$canHideNativeNavbar ? "24px 16px 40px 16px" : "24px 16px 24px 16px"};
			z-index: 4;
			border-top: 1px solid #BABABA;
			box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.08);
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			background: #fff;
			position: fixed;
			bottom: ${props => props.$canHideNativeNavbar ? "30px" : "12px"};
			left: 0px;
			right: 0px;
			padding: ${props => props.$canHideNativeNavbar ? "24px 16px 40px 16px" : "24px 16px 24px 16px"};
			z-index: 4;
		`
	}
`;

const Button = styled.button`
	${props => props.$isContainerTelcel &&
		css`
			width: 100%;
			position: relative;
			border-radius: 100px;
			background-color: #7b1fa2;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 8px 16px;
			box-sizing: border-box;
			min-width: 120px;
			max-width: 358px;
			min-height: 40px;
			max-height: 40px;
			text-align: center;
			font-size: 16px;
			color: #fff;
			margin: auto;
			margin-top: 44px;
			@media (max-width: 380px) {
				max-width: 340px;
			}
		`
	}

	${props => props.$bundleName && props.$bundleName === BUNDLE_CLARO_PAY &&
		css``
	}
`;

const ModalLegales = ({ handleOnClick, isContainerTelcel }) => {

	React.useEffect(() => {
		const handleMessage = (event) => {
			if (event.data && event.data.url) {
				ClaroSDKService.openExternalLinks(event.data.url)
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, []);
	
	const getCloseIcon = () =>{
		switch (isContainerTelcel) {
			case true:
				return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "payment_methods_list_close_icon.png";
		
			default:
				return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "payment_methods_list_close_icon.png";
		}
	}
	
	return (
		<>
			<Backdrop $isContainerTelcel={isContainerTelcel}>
				<Container $isContainerTelcel={isContainerTelcel}>
					<ItemContainer $isContainerTelcel={isContainerTelcel}>
						<CloseText 
							$isContainerTelcel={isContainerTelcel}
							onClick={handleOnClick}
						>
							Cerrar
						</CloseText>
						<CloseIcon
							$isContainerTelcel={isContainerTelcel}
							src={getCloseIcon()}
							alt="close-icon"
							onClick={handleOnClick}
						/>						
					</ItemContainer>
					<ItemContainer $isContainerTelcel={isContainerTelcel}>
						<b className={"title"}>Para hacer cambios en este servicio te dirigiremos a mitelcel.com</b>					
					</ItemContainer>
					<ItemContainer $isContainerTelcel={isContainerTelcel}>
						<div className={"globaltagsalert"}>
							<div className={"interfaceParent"}>
								<div className={"interface"}>
									<img className={"icon"} alt="" src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}/recurrent_icon_tag.png`} />
								</div>
								<div className={"reactivacinTuLnea"}>
									Al presionar el botón saldrás de la aplicación
								</div>
							</div>
						</div>
					</ItemContainer>
					
					<Button 
						$isContainerTelcel={isContainerTelcel}
						onClick={() => {
							const linkInformation = JSON.stringify({
								app: "https",
								url: "https://mitelcel.com/",
							});
							sdkclaro.getInstance().openNative(
									linkInformation,
									(result) => {
										console.debug("OPEN_EXTERNAL_LINK__SUCCESS");
										console.debug(result);
									},
									(error) => {
										console.debug("OPEN_EXTERNAL_LINK__ERROR", error);
										console.debug(error);
									}
								)
							handleOnClick();
						}}>
						Ir a mi Telcel
					</Button>
				</Container>
			</Backdrop>
		</>
	)
}

const mapStateToProps = (state) => {
	const { payments } = state;
	const isContainerTelcel = payments.isContainerTelcel;
	return {
		isContainerTelcel,
	}
}

export default connect(mapStateToProps)(ModalLegales);
